import createHistory from 'history/createBrowserHistory'
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';

import { rootReducer } from './reducers'
import sagas from './sagas';

export const history = createHistory();

export const reduxLoggerMiddleware = createLogger({
  collapsed: true,
  diff: true
});

export const sagaMiddleware = createSagaMiddleware();

export const middleware = composeWithDevTools(
  applyMiddleware(
    reduxLoggerMiddleware,
    sagaMiddleware,
    routerMiddleware(history)
  )
);

export const store = createStore(rootReducer, {}, middleware);

sagaMiddleware.run(sagas);

export default store;



// WEBPACK FOOTER //
// ./src/store.js